import { dashboardUpdateBusinessNotesRequest } from '@/modules/dashboard/dashboardActions';
import type { UserNotes } from '@/modules/dashboard/dashboardTypes';
import type { RootState } from '@/rootReducer';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

export const useSaveNoteMutation = () => {
	const dispatch = useDispatch();

	const mutate = (
		businessId: string,
		businessName: string,
		notes: UserNotes
	) => {
		dispatch(
			dashboardUpdateBusinessNotesRequest({
				businessId,
				businessName,
				notes
			})
		);
	};

	const [isLoading, isError] = useSelector<RootState, [boolean, boolean]>(
		state => [
			state.dashboard.getIn(['notes', 'isLoading']),
			state.dashboard.getIn(['notes', 'failure'])
		],
		shallowEqual
	);

	return { mutate, isLoading, isError };
};
